import { Injectable } from '@angular/core';
import { ApiService } from '@core/auth/auth.service';
import { ConfirmationModalService } from '@core/customCDK/cdkCustomMdl/services/confirmation-modal.service';
import { CustomOtpViewComponent } from '@core/custome-modal/custom-otp/custom-otp-view/custom-otp-view.component';
import { config } from '@core/interfaces/api_baseurl';

@Injectable({
  providedIn: 'root'
})
export class ApiAccessControlService {

  constructor(
    private _ApiService: ApiService,
    private _ConfirmationModalService: ConfirmationModalService,
  ) { }

  apiAccessVerifyOtp(otp: string) {
    const reqBody = {
      otp: otp
    }
    return this._ApiService.post(config.Api_Key.verifyOTP, reqBody);
  }

  sendOtp(formdata: any) {
    return this._ApiService.post(config.Api_Key.sendOTP, formdata);
  }

  OtpModal(data?: any) {
    data = {
      showCloseIcon: true, //show submit button
      title: 'Enter OTP', //show mesg send to mobile
      message: 'We have sent you OTP to your registered phone number/email id for verification', //show mesg send to mobile
      // isSubmitBtn: true, //show submit button
      submitBtnName: 'Submit OTP', //show submit button
      submitBtnClass: 'btn btn-primary',
      otpBox: 4,
      ...data
    }
    const otpMdlInstans = this._ConfirmationModalService.init(CustomOtpViewComponent, {
      data
    });
    return otpMdlInstans;
  }

}
